import { Component, inject, input, OnDestroy, signal } from '@angular/core';

import { MessageListStore } from '../../message-list.store';
import { ChatService } from '../../service/chat.service';
import { UserStore } from '../../user.store';

@Component({
  selector: 'app-strange-number-warning',
  standalone: true,
  imports: [],
  templateUrl: './strange-number-warning.component.html',
  styleUrl: './strange-number-warning.component.scss',
})
export class StrangeNumberWarningComponent implements OnDestroy {
  chatService = inject(ChatService);
  messageListStore = inject(MessageListStore);
  userStore = inject(UserStore);
  userID = input('');
  warningMessage = signal<string | null>(null);
  isCalling = input(false);

  constructor() {
    // effect(
    //   async () => {
    //     const messageListLength = this.messageListStore.rawMessageList().length;
    //     const cache = this.isCalling()
    //       ? this.strangeNumberWarningService.callWarningMessageCache
    //       : this.strangeNumberWarningService.warningMessageCache;
    //     if (!messageListLength && cache.has(this.userID())) {
    //       this.warningMessage.set(cache.get(this.userID()) || null);
    //       this.strangeNumberWarningService.setIsLoading(false);
    //       return;
    //     }
    //     if (cache.get(this.userID()) === null) {
    //       this.warningMessage.set(null);
    //       return;
    //     }
    //     const phoneNumber = await this.userStore.getPhoneNumber(this.userID(), true);
    //     if (phoneNumber) {
    //       await this.refreshWarningMessage(this.userID(), phoneNumber);
    //     }
    //   },
    //   {
    //     allowSignalWrites: true,
    //   },
    // );
  }

  ngOnDestroy(): void {
    // this.strangeNumberWarningService.setIsLoading(true);
  }

  private async refreshWarningMessage(userId: string, phoneNumber: string) {
    // if (!userId || !phoneNumber) {
    //   this.warningMessage.set(null);
    //   return;
    // }
    // this.warningMessage.set(null);
    // const msg = await this.strangeNumberWarningService.getWarningMessage(
    //   userId,
    //   phoneNumber,
    //   this.isCalling(),
    // );
    // this.warningMessage.set(msg);
  }
}
